module.exports = __webpack_public_path__ + "img/video@2x.893dfdf1.png";